<div class="container-fluid padMob" style="padding-left: 25px; padding-right: 0px; font-size: 14px;">
    <!-- Header -->
    <div class="row" style="padding-top: 10px; margin: 0px;">
        <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="padding: 0px">
            <div class="col-md-6 col-sm-4 col-4 lblHeader newHeader" 
                style="font-size: 30px; display: inline-block; vertical-align: bottom; padding-left: 0px;">
                Attendance
            </div>
        </div>
    </div>

    <div class="row" style="margin-top: 10px;">
        <div class="col-md-12" style="padding: 0px; display: inline-block;">
            <div class="pdf5" style="display: inline-block;">
                <label style="padding-left: 8px;">Attendance : </label>
            </div>
            <div class="pdf5" style="display: inline-block;">
                <input name="102" type="radio" ng-model="selectedAtndViewTyp" value="dateWise" class="" id="radio106" ng-change="changeAtndViewTyp()" tabindex="1">
                <label class="pdf5" for="radio106">Date-wise</label>
            </div>
            <div class="pdf5" style="display: inline-block;">
                <input name="102" type="radio" ng-model="selectedAtndViewTyp" value="empWise" class="" id="radio107" ng-change="changeAtndViewTyp()" tabindex="1">
                <label class="pdf5" for="radio107">Employee-wise</label>
            </div>
        </div>

        <div class="col-md-12" style="padding: 0px; display: inline-block;">
            <!-- <div class="pdf5" style="display: inline-block;">
                <label style="padding-left: 8px;">Date : </label>
                <span style="font-size: 14px !important; padding-left: 10px;">
                    <input matInput readonly [matDatepicker]="picker2" id="fromdate" (click)="picker2.open()" [(ngModel)]="fromDate" 
                    style="cursor: pointer; font-size: 14px; border-bottom-width: 1px; margin-left: 8px; border-top: 0px; border-left: 0px; padding: 0px; border-right: 0px;width: 75px;">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2 color="primary"></mat-datepicker>
            </span>
            </div> -->

        </div>

    </div>


    <div class="col-md-12 col-12 col-sm-12 pad0" style="padding-right: 20px; margin-top: 15px; width: 80%; padding-left: 0px;">
        <div class="col-md-12 col-12 col-sm-12 pad0 bzMatTbl shadow" style="padding: 0px;">
            <table mat-table [dataSource]="dataSource" style="width: 100%; border-radius: 10px; cursor: pointer;">
            
            <!-- Position Column -->
            <ng-container matColumnDef="Name">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef style="font-weight: bold;font-size: medium;width: 20%;"> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.Name}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="Date" style="width: 9%;">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef style="width: 12%;"> Date </th>
                <td mat-cell *matCellDef="let element"> {{element.Date}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="Day">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef style="width: 12%;"> Day </th>
                <td mat-cell *matCellDef="let element"> {{element.Day}} </td>
            </ng-container>

            <ng-container matColumnDef="Status">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef > Status </th>
                <td mat-cell *matCellDef="let element"> 
                <select class="form-control font13 bdrrd10 bgwhite" style="display: inline-block; padding: 1px 3px; font-size: 13px; cursor: pointer; width:130px">
                    <option label="--select--">{{element.Status}}</option>
                    <option value="Fullday">Fullday</option>
                    <option value="Halfday">Halfday</option>
                    <option value="Absent">Absent</option>
                    <option value="Holiday">Holiday</option>
                    <option value="Leave">Leave</option>
                    <option value="Overtime">Overtime</option>
                    <option value="Unknown">Unknown</option>]
                </select>
                </td>
            </ng-container>

            <ng-container matColumnDef="Considaration">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef> Considaration </th>
                <td mat-cell *matCellDef="let element"> {{element.Considaration}} </td>
            </ng-container>

            <ng-container matColumnDef="Notes">
                <th class="header header-Table" mat-header-cell *matHeaderCellDef style="width: 27%;" style="border-radius: 10px;"> Notes </th>
                <td mat-cell *matCellDef="let element">
                     <input  class="form-control" type="text" name="note" style="height: 25px; position: relative; bottom: 1px; background-color: inherit;"> </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns" ></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <mat-paginator [pageSize]="10" [pageSizeOptions]="[5,10, 20]">
            </mat-paginator>
        </div>
    </div>
</div>


